var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customAlert mx-auto mt-2"},[_c('b-alert',{attrs:{"show":"","dismissible":"","variant":"warning"},on:{"dismissed":function($event){return _vm.onDismiss()}}},[_vm._v(" "+_vm._s(_vm.$t("Generation of assets was not able to complete. Try again"))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }